// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"dc71e29c","245":"74af52c6","340":"45fd6915","416":"407635f0","661":"e6e79cfb","682":"62e21991","839":"ae82c1ed","996":"bb70caaf"}[chunkId] + ".chunk.js";
};